import { render, staticRenderFns } from "./RobberyDuringAbsenceQuestion.vue?vue&type=template&id=66a9f9b1&scoped=true"
import script from "./RobberyDuringAbsenceQuestion.vue?vue&type=script&lang=ts"
export * from "./RobberyDuringAbsenceQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a9f9b1",
  null
  
)

export default component.exports